module.exports = __webpack_public_path__ + "img/firetalks.83a67e91.svg";